import { StyleSheet, View, type ViewProps } from 'react-native';
import { type ReactNode } from 'react';

import { Container, Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type SectionProps = ViewProps & {
  eyebrow?: string;
  title?: ReactNode;
  lede?: string;
  narrow?: boolean;
  paddingY?: number;
};

export function Section({ eyebrow, title, lede, narrow, paddingY = 96, style, children, ...rest }: SectionProps) {
  const theme = useTheme();
  return (
    <View style={[{ paddingVertical: paddingY }, style]} {...rest}>
      <Container narrow={narrow}>
        {(eyebrow || title || lede) && (
          <View style={styles.head}>
            {eyebrow ? (
              <Text variant="eyebrow" tone="fgMute" style={{ color: theme.colors.accent }}>
                {eyebrow}
              </Text>
            ) : null}
            {title ? (
              <Text variant="h1" style={{ marginTop: 16, maxWidth: 760 }}>
                {title}
              </Text>
            ) : null}
            {lede ? (
              <Text variant="bodyLarge" tone="fgSoft" style={{ marginTop: 20, maxWidth: 680 }}>
                {lede}
              </Text>
            ) : null}
          </View>
        )}
        {children}
      </Container>
    </View>
  );
}

const styles = StyleSheet.create({
  head: { marginBottom: 48 },
});
